module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBd.svg?v=070f676c7a7a9067e2d260e7e951d424";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBd.svg
// module id = 636
// module chunks = 0